import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import clsx from 'clsx';
import { InfoIcon } from 'reaxl';
import { formatNumber } from '@atc/string-fns';
import _get from 'lodash/get';
import { useDevice } from '@atc/react-device';

/**
 * FilterCheckboxLabel will render a formatted presentation of a checkbox label.
 *
 */
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
function FilterCheckboxLabel(_ref) {
  let {
    label,
    count,
    disabled,
    moreInfo,
    filterBadge,
    onCloseClick,
    showCount = true
  } = _ref;
  const device = useDevice();
  const isXs = _get(device, 'is.xs', false);
  const countDisplay = useMemo(() => {
    if (count) {
      return `(${formatNumber({
        value: count
      })})`;
    }
    if (disabled) {
      return '(0)';
    }
    return '';
  }, [count, disabled]);
  const moreInfoOverlayTriggerHandler = e => {
    if (!isXs) {
      e.stopPropagation();
    }
    e.preventDefault();
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("span", {
      children: label
    }, "label"), /*#__PURE__*/_jsxs("span", {
      className: "text-nowrap",
      children: [showCount && count !== undefined && /*#__PURE__*/_jsxs("span", {
        className: clsx({
          'text-gray': !disabled
        }),
        children: [' ', countDisplay]
      }, "count"), moreInfo && /*#__PURE__*/_jsxs("span", {
        children: [' ', /*#__PURE__*/_jsx(InfoIcon, {
          popoverId: "filter-more-info-popover",
          onClick: moreInfoOverlayTriggerHandler,
          placement: "bottom",
          infoText: moreInfo,
          onCloseClick: onCloseClick
        })]
      }, "more-info"), filterBadge && /*#__PURE__*/_jsx("span", {
        className: "margin-left-2 text-success text-bold",
        children: filterBadge
      })]
    }, "additional-info")]
  });
}
export default FilterCheckboxLabel;